import React from 'react'
import styled from "styled-components"
import { SiGmail } from "react-icons/si";
import {
  FaPhone,
  FaGithub,
  FaLinkedin,
  FaTwitter,
  FaHackerrank,
  // FaMedium,
} from "react-icons/fa";
import ShareLocationIcon from "@mui/icons-material/ShareLocation";






function Contact() {

  return (
    <>
      <Container>
        <H1>Get in touch 🤙 </H1>
        <H2>
          Thanks for stopping by, I’m currently looking to join a new team of
          creative designers and developers. If you think we might be a good fit
          for one another, give me a call 🇮🇳 or send me an email
        </H2>
        <H1> Dont be a stranger! 👋 </H1>
        <H3>Let's connect:</H3>

        <Foot>
          <div>
            <span>
              <a className="phone" href="tel:+8105086693" title="Phone">
                <FaPhone />
              </a>
              <h4> +91 8105086693 </h4>
            </span>

            <span>
              <a
                className="email"
                href="mailto: getsushanthps@gmail.com"
                target="_blank"
                rel="noreferrer"
                title="Email"
              >
                <SiGmail />
              </a>
              <H4> vikramamin66@gmail.com </H4>
            </span>

            <span>
              <a
                className="linkedin"
                href="https://linkedin.com/in/vikram-amin-52b55815a"
                target="_blank"
                rel="noreferrer"
                title="Linkedin"
              >
                <FaLinkedin />
              </a>
              <H4> https://linkedin.com/in/vikram-amin-52b55815a </H4>
            </span>
            <span>
              <a
                className="twitter"
                href="https://twitter.com/vikram56201675"
                target="_blank"
                rel="noreferrer"
                title="Linkedin"
              >
                <FaTwitter />
              </a>
              <H4> https://twitter.com/vikram56201675 </H4>
            </span>
            <span>
              <a
                className="github"
                href="https://github.com/Vikram-amin"
                target="_blank"
                rel="noreferrer"
                title="Github"
              >
                <FaGithub />
              </a>
              <H4> https://github.com/Vikram-amin</H4>
            </span>
            <span>
              <a
                className="hackerrank"
                href="https://www.hackerrank.com/vikramamin"
                target="_blank"
                rel="noreferrer"
                title="HackerRank"
              >
                <FaHackerrank />
              </a>
              <H4> https://www.hackerrank.com/vikramamin </H4>
            </span>
            <span className='location'>
              <ShareLocationIcon />
              <H4 className='locationName'> Udupi, Karnataka </H4>
            </span>
          </div>
        </Foot>
      </Container>
    </>
  );
}

const Container = styled.div`
  margin: 2rem auto;
  width: 83%;

`;

const H1 = styled.h1`
  color: ${(props) => props.theme.text.main};
  margin-top:70px;
`;

const H3 = styled.h2`
  color: ${(props) => props.theme.text.main};
  margin-top: 10px;
`;

const H2 = styled.h2`
  color: ${(props) => props.theme.text.secondary};
`;


const H4 = styled.h4`
  color: ${(props) => props.theme.text.secondary};
`;
const Foot = styled.div`
  color: rgb(234, 236, 222);

  div {
    flex-direction: column;
  }

  span {
    display: flex;
  }

  h4 {
    padding-left: 15px;
    margin-top: 10px;
  }

  a {
    color: inherit;
    text-decoration: inherit;
    margin: 10px;
  }
  .location {
    color: inherit;
    text-decoration: inherit;
    margin: 10px;
  }

  .locationName {
    padding-left: 25px;
    margin-top: 2px;
  }

  svg {
    font-size: 30px;
    cursor: pointer;

    @media only screen and (max-width: 767px) {
      font-size: 20px;
    }
  }

  .linkedin:hover {
    color: #0866c2;
  }
  .twitter:hover {
    color: #1d9bf0;
  }

  .github:hover {
    color: #161b22;
  }

  .hackerrank:hover {
    color: #2fc866;
  }

  .email:hover {
    color: #ea4335;
  }

  .phone:hover {
    color: cyan;
  }
`;



export default Contact